import axios from 'axios';

import { MessageDialog } from '../../framework/frontend/MessageDialog';
import { AwsFile } from '../pages/files/section/AwsFile';
import { translation } from '../lang/Translation';

const t = translation;
export type FileType = 'movie' | 'image' | 'model' | 'sound' | 'other' | 'vrm_anim';

export async function deleteUserAsset(
  userId: number,
  token: string,
  fileName: string
): Promise<boolean> {
  const result = await MessageDialog.confirm(t.to('削除します', 'msg_del'));
  if (result) {
    const url = `../webapi/file/filedelete_api?user_id=${userId}&fileName=${getFileNameFromPath(
      fileName
    )}&token=${token}`;
    await axios.post(url);
    return true;
  }
  return false;
}

const imageExtentions = ['.png', '.jpg', '.jpeg', '.gif', '.heic'];
const gltfExtentions = ['.gltf', '.glb'];
const vrmExtentions = ['.vrm'];
const vrmAminExtentions = ['.vmd', '.bvh'];
const movieExtentions = ['.mp4'];
const soundExtentions = ['.mp3'];
const otherExtentions = ['.zip', '.mind']; //'.fset', '.fset3', '.iset', '.zft', '.bin'
function allExtentions(): string[] {
  return []
    .concat(imageExtentions)
    .concat(movieExtentions)
    .concat(soundExtentions)
    .concat(gltfExtentions)
    .concat(vrmExtentions)
    .concat(vrmAminExtentions)
    .concat(otherExtentions);
}
export function isMovie(fileName: string): boolean {
  return movieExtentions.some((ext) => fileName.endsWith(ext));
}

export function isImage(fileName: string): boolean {
  return imageExtentions.some((ext) => fileName.endsWith(ext));
}

export function is_glTF(fileName: string): boolean {
  return gltfExtentions.some((ext) => fileName.endsWith(ext));
}

export function is_vrm(fileName: string): boolean {
  return vrmExtentions.some((ext) => fileName.endsWith(ext));
}

export function is_bvh(fileName: string): boolean {
  return vrmAminExtentions.some((ext) => fileName.endsWith(ext));
}

export function isSound(fileName: string): boolean {
  return soundExtentions.some((ext) => fileName.endsWith(ext));
}

export function isOther(fileName: string): boolean {
  return otherExtentions.some((ext) => fileName.endsWith(ext));
}

function getLowerFileName(fileName: string): string {
  return fileName.toLowerCase();
}

export function getType(fileName: string): FileType {
  const lowerFileName = getLowerFileName(fileName);
  if (isImage(lowerFileName)) {
    return 'image';
  }
  if (isMovie(lowerFileName)) {
    return 'movie';
  }
  if (is_glTF(lowerFileName)) {
    return 'model';
  }
  if (is_vrm(lowerFileName)) {
    return 'model';
  }
  if (isSound(lowerFileName)) {
    return 'sound';
  }
  if (is_bvh(lowerFileName)) {
    return 'vrm_anim';
  }
  return 'other';
}
function getFileNameFromPath(fileName: string): string {
  return fileName.split('/').reverse()[0];
}
export class SupportFiles {
  /**
   * アップロード可能な拡張子を定義
   */
  static get acceptExtentions(): string {
    return allExtentions().join(',');
  }

  protected fileName = '';

  public get fileNameFromPath(): string {
    return decodeURIComponent(this.fileName.split('/').reverse()[0]);
  }

  public get type(): FileType {
    return getType(this.fileName);
  }
}

export interface UserFile {
  get fileNameFromPath(): string;
  get assetPath(): string;
  get size(): number;
  get type(): string;
  get lastModified(): string;
}

export class UserFileImpl extends SupportFiles {
  private constructor() {
    super();
  }

  static instanceFromAwsFile(file: AwsFile): UserFile {
    const instance = new UserFileImpl();
    instance.fileName = file.Key;
    return instance;
  }

  static instance(fileName: string): UserFile {
    const instance = new UserFileImpl();
    instance.fileName = fileName;
    return instance;
  }

  public get assetPath(): string {
    return '/assets/' + this.fileName;
  }

  public get size(): number {
    return 0;
  }
  public get lastModified(): string {
    return '';
  }
}
